import React, { useCallback, useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  List,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItem
} from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import LinearProgress from '@material-ui/core/LinearProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import NavItem from './NavItem';
import GroupApi from '../../../utils/apiManager/constrollers/groupApi';
import {
  addGroups,
  deleteGroup,
  addGroup,
  renameGroup,
} from '../../../redux/reducers/groups/actions';
import { addCategories, addCategory } from '../../../redux/reducers/categories/actions';
import { getGroups } from '../../../redux/reducers/groups/selectors';
import MenuItemCustom from './MenuItemCustom';
import CategoryApi from '../../../utils/apiManager/constrollers/categoryApi';

const styles = (theme) => ({
  icon: {
    marginRight: theme.spacing(1),
    fontSize: '1.5rem',
    margin: '0 0 0 18px'
  },
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  mobileDrawer: {
    width: 350
  },
  foldersArea: {
    flex: '0 0 auto',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    maxWidth: 350,
    mapgin: 0,
    zIndex: 1200,
    overflowY: 'auto',
    left: 0,
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%'
    }
  },
  desktopDrawer: {
    width: 310,
    top: 0,
    height: '100%'
  },
  templateThumb: {
    margin: '0 4px 0px 4px',
    cursor: 'pointer',
    width: 60,
    height: 60,
    display: 'flex',
    border: '1px solid',
    borderColor: '#dddee1',
    backgroundColor: '#00000',
  },
  iconFolderOpen: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: 20,
  },
  group: {
    fontSize: '1rem',
    width: '293px',
    boxShadow: 'none',
    margin: 0,
    padding: 0,
    '&$elevation': {
      boxShadow: 'none'
    },
    '&::before': {
      height: 0
    },
    '& $expanded': {
      margin: 0,
      padding: 0,
    }
  },
  textGroup: {
    fontWeight: theme.typography.fontWeightMedium,
    fontFamily: 'Roboto',
    color: '#000',
    backgroundColor: 'transparent',
    fontSize: '1rem',
    padding: '1px 0 0 7px',
    border: 0
  },
  folderOpenIcon: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '1.5rem',
    padding: 0,
    margin: 0
  },
  iconAddFolder: {
    position: 'relative',
    fontSize: 10,
    width: '25px',
    height: '25px',
    margin: '-36px 0 0 -70px',
  },
  iconAddGroup: {
    position: 'relative',
    fontSize: 20,
    margin: '3px 7px 0 0',
    opacity: 1,
    '&:hover': {
      borderColor: '#dddee1',
      boxShadow: '1px',
      opacity: 1
    }
  },
  myFolders: {
    margin: '10px 0 20px 0 10px',
    padding: '15px 0 20px 23px',
    [theme.breakpoints.down('sm')]: {
      padding: '15px 0 20px 33px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '15px 0 20px 43px',
    }
  },
  myFoldersText: {
    margin: '10px 0 20px 0',
    fontSize: '1rem',
  },
  button: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexFlow: 'row',
    color: theme.palette.text.secondary,
    fontSize: '1rem',
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: 0,
    padding: '10px 8px',
    margin: '6px 0 6px 0',
    textTransform: 'none',
    width: '100%',
    transition: 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f4f6f8',
    }
  },
  boxList: {
    margin: '-9px 0 0 0',
    padding: 0
  },
  buttonAdd: {
    color: 'rgb(44, 56, 126)',
    float: 'right',
    margin: '-26px 32px 0 0',
    fontSize: 28,
    cursor: 'pointer'
  },
  allImagesRow: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 56,
    padding: '0 20px 0 0',
    backgroundColor: 'rgba(255,255,255,1)',
    borderRadius: 4,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f4f6f8',
    },
  },
});

const MyAccordion = withStyles({
  root: {
    border: 0,
    padding: '0 20px 0 0',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 0,
    },
  },
  expanded: {},
})(Accordion);

const MyAccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(255,255,255,1)',
    borderBottom: 0,
    borderRadius: 4,
    padding: 0,
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
      backgroundColor: '#fff',
    },
    '&:hover': {
      backgroundColor: '#f4f6f8',
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(AccordionSummary);

const MyAccordionDetails = withStyles(() => ({
  root: {
    padding: 0,
  },
}))(AccordionDetails);

const NavBar = (props) => {
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const [expanded, setExpanded] = useState(props.lastUsedGroupId);
  const [addGroupActive, setAddGroupActive] = useState(false);
  const [delAlert, setDelAlert] = useState({
    show: false,
    message: '',
    groupId: '',
  });
  const [showProgress, setProgress] = useState(false);
  const [renamingGroup, setRenamingGroup] = useState(null);
  const [style, setStyle] = useState({ display: 'none' });

  useEffect(() => {
    if (props.openMobile && props.onMobileClose) {
      props.onMobileClose();
    }
  }, []);

  useEffect(() => {
    setExpanded(props.lastUsedGroupId);
    const fetchCategories = async (groupId) => {
      const categoryApi = await CategoryApi.getInstance();

      const fetchedCategories = await categoryApi.fetchCategories(groupId);
      if (fetchedCategories) {
        props.addCategories(fetchedCategories, groupId);
      }
    };
    if (props.lastUsedGroupId) {
      if (!props.categories[props.lastUsedGroupId]) {
        setProgress(true);
        fetchCategories(props.lastUsedGroupId).then(() => {
          setProgress(false);
          forceUpdate();
        }).catch(() => {
          setProgress(false);
        });
      }
    }
  }, [props.lastUsedGroupId]);

  const putGroup = async (title) => {
    if (title.length) {
      const groupApi = await GroupApi.getInstance();
      const isAdded = await groupApi.addGroup(title);
      if (isAdded) {
        props.addGroup({
          id: isAdded.id,
          title,
        });
        document.getElementById('mockedAddGroupInput').value = '';
        setAddGroupActive(false);
      }
    }
  };

  const putCategory = async (title, groupId) => {
    if (title.length) {
      const categoryApi = await CategoryApi.getInstance();
      const isAdded = await categoryApi.addCategory(title, groupId);
      if (isAdded) {
        props.addCategory({
          id: isAdded.id,
          title,
          groupId,
        });
      }
      document.getElementById(`mockedAddCategoryInput${groupId}`).value = '';
      forceUpdate();
    }
  };

  const handleAddGroup = async (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      await putGroup(event.target.value);
    } else if (event.key === 'Escape') {
      document.getElementById('mockedAddGroupInput').value = '';
      setAddGroupActive(false);
    }
  };

  const handleAddCategory = async (event, groupId) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      await putCategory(event.target.value, groupId);
    } else if (event.key === 'Escape') {
      document.getElementById(`mockedAddCategoryInput${groupId}`).value = '';
    }
  };

  const updateGroup = async (value, group) => {
    try {
      const groupApi = await GroupApi.getInstance();
      await groupApi.renameGroup(value, group);
      props.renameGroup({
        groupId: group.id,
        title: value,
      });
    } catch (e) {
      document.getElementById(`${group.id}renameGroup`).value = group.title;
    }
  };

  const handleRenameGroup = async (event, group) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      await updateGroup(event.target.value, group);
      setRenamingGroup(null);
    } else if (event.key === 'Escape') {
      document.getElementById(`${group.id}renameGroup`).value = group.title;
      setRenamingGroup(null);
    }
  };

  const handleDeleteGroup = async () => {
    const { groupId } = delAlert;
    setDelAlert({
      show: false,
      message: '',
      groupId: '',
    });
    if (groupId) {
      const groupApi = await GroupApi.getInstance();
      const isDeleted = await groupApi.deleteGroup(groupId);
      if (isDeleted) {
        props.deleteGroup(groupId);
      }
    }
  };

  const handleChange = (expGroupId) => {
    return async (event, isExpanded) => {
      console.log(1);
      console.log(isExpanded);
      setExpanded(isExpanded ? expGroupId : false);
      const fetchCategories = async (groupId) => {
        const categoryApi = await CategoryApi.getInstance();

        const fetchedCategories = await categoryApi.fetchCategories(groupId);
        if (fetchedCategories) {
          props.addCategories(fetchedCategories, groupId);
        }
      };

      if (expGroupId) {
        if (!props.categories[expGroupId]) {
          setProgress(true);
          fetchCategories(expGroupId).then(() => {
            setProgress(false);
            forceUpdate();
          }).catch(() => {
            setProgress(false);
          });
        }
      }
    };
  };

  const handleClickDeletionAlertOpen = (groupId) => {
    const group = props.groups.find((el) => el.id === groupId);
    setDelAlert({
      show: true,
      message: group?.title,
      groupId,
    });
  };

  const handleDeletionAlertClose = () => {
    setDelAlert({
      show: false,
      message: '',
      groupId: '',
    });
  };

  const activateRenamingInput = (id) => {
    setRenamingGroup(id);
  };

  const location = useLocation();
  const isAllImages = location.pathname === '/app/all-images';

  const { classes, className } = props;

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <Box className={classes.myFolders}>
        <Box className={classes.myFoldersText}>
          <Typography
            color="textPrimary"
            variant="h4"
          >
            <FormattedMessage id="label.myFolders" defaultMessage="My Folders"/>
          </Typography>
          <AddCircleIcon className={classes.buttonAdd} onClick={() => setAddGroupActive(true)}/>
        </Box>
        <Box>
          <RouterLink
            to="/app/all-images"
            style={{ textDecoration: 'none' }}
            onClick={() => setExpanded(false)}
          >
            <Box
              className={classes.allImagesRow}
              style={isAllImages ? { backgroundColor: '#f4f6f8' } : {}}
            >
              <FolderOpenIcon
                className={classes.folderOpenIcon}
                size="20"
                style={isAllImages ? { color: '#3f51b5' } : {}}
              />
              <span
                className={classes.textGroup}
                style={isAllImages ? { color: '#3f51b5' } : {}}
              >
                <FormattedMessage id="label.allImages" defaultMessage="All Images" />
              </span>
            </Box>
          </RouterLink>
          <MyAccordion
            key='mockedAddGroup'
            classes={{ root: classes.group }}
            style={addGroupActive ? { display: 'block' } : { display: 'none' }}
          >
            <MyAccordionSummary
              padding="0"
              onMouseEnter={() => {
                setStyle({ display: 'block' });
              }}
              onMouseLeave={() => {
                setStyle({ display: 'none' });
              }}
            >
              <FolderOpenIcon
                className={classes.folderOpenIcon}
                size="20"
              />
              <input
                id='mockedAddGroupInput'
                type='text'
                className={classes.textGroup}
                placeholder='Add new group...'
                onKeyDown={(event) => handleAddGroup(event)}
                onBlur={() => {
                  document.getElementById('mockedAddGroupInput').value = '';
                  setAddGroupActive(false);
                }}
              />
            </MyAccordionSummary>
          </MyAccordion>
          {props.groups.map((group) => (
            <MyAccordion
              key={group.id}
              classes={{ root: classes.group }}
              expanded={expanded === group.id}
              onChange={handleChange(group.id)}
            >
              <MyAccordionSummary
                padding="0"
                onMouseEnter={() => {
                  setStyle({ display: 'block' });
                }}
                onMouseLeave={() => {
                  setStyle({ display: 'none' });
                }}
              >
                <FolderOpenIcon
                  className={classes.folderOpenIcon}
                  size="20"
                  disabled
                />
                <span style={{ position: 'relative' }}>
                  <input
                    id={`${group.id}renameGroup`}
                    type='text'
                    className={classes.textGroup}
                    onBlur={() => {
                      setRenamingGroup(null);
                      document.getElementById(`${group.id}renameGroup`).value = group.title;
                    }}
                    onClick={((event) => event.stopPropagation())}
                    disabled={renamingGroup !== group.id}
                    style={{
                      cursor: renamingGroup !== group.id ? 'pointer' : 'auto',
                    }}
                    defaultValue={group.title}
                    onKeyDown={(event) => handleRenameGroup(event, group)}
                  />
                  <span style={{
                    display: renamingGroup !== group.id ? 'block' : 'none',
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                  }} />
                </span>
                <MenuItemCustom
                  id={group.id}
                  style={style}
                  items={[
                    {title: 'Rename', onCustomClick: activateRenamingInput},
                    {title: 'Delete', onCustomClick: handleClickDeletionAlertOpen},
                  ]}
                />
              </MyAccordionSummary>
              <MyAccordionDetails>
                <Box width="100%">
                  <List
                    className={classes.boxList}
                  >
                    <LinearProgress style={ showProgress ? { display: 'block' } : { display: 'none' }}/>
                    <ListItem
                      className={clsx(classes.item, className)}
                      disableGutters
                    >
                      <div
                        className={classes.button}
                      >
                        <AddCircleOutlineIcon
                          className={classes.icon}
                          size="20"
                        />
                        <input
                          id={`mockedAddCategoryInput${group.id}`}
                          type='text'
                          className={classes.textGroup}
                          placeholder='Add new category...'
                          onKeyDown={(event) => handleAddCategory(event, group.id)}
                          onBlur={() => {
                            document.getElementById(`mockedAddCategoryInput${group.id}`).value = '';
                          }}
                        />
                      </div>
                    </ListItem>
                    {props.categories[group.id]?.map((item) => (
                      <NavItem
                        href={item.href}
                        key={item.id}
                        title={item.title}
                        count={item.count}
                        id={item.id}
                        groupId={group.id}
                        icon={FolderOpenIcon}
                        width="100%"
                      />
                    ))}
                  </List>
                  {/* <IconButton aria-label="addcategory" size="small"
                  className={classes.iconAddCategory} title="Add Category">
                    <AddIcon />
                  </IconButton> */}
                </Box>
              </MyAccordionDetails>
            </MyAccordion>
          ))}
        </Box>
        {/* <IconButton aria-label="share" size="small"
        className={classes.iconAddFolder} title="Add Folder">
          <AddIcon />
        </IconButton> */}
      </Box>

      <Box flexGrow={1} />
      <Dialog
        open={delAlert.show}
        onClose={handleDeletionAlertClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure that you want to delete
          {' '}
          <b>{delAlert.message}</b>
          {' '}
          group?
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleDeletionAlertClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteGroup} color="primary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      {/* <Box
        p={2}
        m={2}
        bgcolor="background.dark"
      >
        <Typography
          align="center"
          gutterBottom
          variant="h4"
        >
          Need more?
        </Typography>
        <Typography
          align="center"
          variant="body2"
        >
          Upgrade and get 10x more recognitions
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          mt={2}
        >
          <Button
            color="primary"
            component="a"
            href="/"
            variant="contained"
          >
            See PRO version
          </Button>
        </Box>
      </Box> */}
    </Box>
  );

  return (
    <>
      <Box className={classes.foldersArea}>
        {content}
      </Box>
    </>
  );
};

NavBar.propTypes = {
  classes: PropTypes.object.isRequired,
  onMobileClose: PropTypes.func,
  className: PropTypes.string,
  addGroups: PropTypes.func,
  addCategory: PropTypes.func,
  addGroup: PropTypes.func,
  deleteGroup: PropTypes.func,
  renameGroup: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: true
};

export default connect(
  getGroups,
  {
    addGroups,
    addCategory,
    addCategories,
    deleteGroup,
    addGroup,
    renameGroup,
  }
)(withStyles(styles)(NavBar));
